// @flow

import update from 'immutability-helper';
import type {ReduxActionType} from "../../flow/ReduxActionType";

const INITIAL_STATE = {
    settings : {
        website_topic: "",
        apply_on_content: 'all',
        languages: [],
        urls: [
            {
                url: '',
                source: 'original',
                source_type: 'wildcard',
            }
        ],
        apply_to_urls: 'all',
        apply_to_languages: 'all',
        enable_mode: 'disabled',
        content_purpose: "technical",
        content_purpose_enabled: false,
        content_purpose_other: null,
        formality: null,
        formality_enabled: false,
        sentence_structure: null,
        sentence_structure_enabled: false,
        target_audience: null,
        target_audience_enabled: false,
        override_default_translations: false,
        force_replace_before: null,
        override_manual_and_selected: false,
        model: null
    },
    dirty: false,
    saving: false,
    saved: false
};

type State = { type?: string };

const AiSettings = (state: State = INITIAL_STATE, action: ReduxActionType) => {
    switch (action.type) {
        case 'AI_SETTINGS_LOADED':
            let settings = INITIAL_STATE.settings;

            // Case new settings
            if (action.payload === null) {
                return {...state, settings: settings};
            }

            // Merge loaded item with default state
            Object.keys(action.payload).forEach((key)=>{
                // ignore unused keys from old code
                if (!Object.prototype.hasOwnProperty.call(INITIAL_STATE.settings, key)) {
                    return;
                }

                settings = update(settings, {[key]: {$set: action.payload[key]}});

                // old config is array, after merged and still aray, just set it to default
                if (Array.isArray(settings.apply_to_languages)) {
                    settings.apply_to_languages = INITIAL_STATE.settings.apply_to_languages;
                }
            });

            if (action.payload.urls !== undefined) {
                settings.apply_to_urls = 'some';
            }

            if (action.payload.languages !== undefined) {
                settings.apply_to_languages = 'some';
            }

            if (action.payload.enable_mode === undefined) {
                settings.enable_mode = 'disabled';
            }

            return {...state, settings: settings, dirty: false};

        case 'AI_SETTINGS_CHANGE_INPUT':
            const result = /(.*)\[([0-9]+)\](.*)?/.exec(action.payload.name);
            if (result && result[3] === undefined) {
                let new_state;
                    new_state = update(state, {settings: {[result[1]]: {[parseInt(result[2])]: {$set: action.payload.value}}}, dirty: {$set: true}});
                return {...new_state};
            } else if (result) {
                let new_state;
                    new_state = update(state, {settings: {[result[1]]: {[parseInt(result[2])]: {[result[3]]: {$set: action.payload.value}}}}, dirty: {$set: true}});
                
                return {...new_state};
            }
                return update(state, {settings: {[action.payload.name]: {$set: action.payload.value}}, dirty: {$set: true}});

        case 'AI_SETTINGS_SUB_ADD':
            switch (action.payload.type) {
                case 'urls':
                    let urls = [...state.settings.urls];
                    urls.push(INITIAL_STATE.settings.urls[0]);
                    return update(state, {settings: {urls: {$set: urls}}, dirty: {$set: true}});
                default:
                    return {...state};
            }

        case 'AI_SETTINGS_SUB_DELETE':
            switch (action.payload.type) {
                case 'urls':
                    let urls = [...state.settings.urls];
                    urls.splice(action.payload.index, 1);
                    return update(state, {settings: {urls: {$set: urls}}, dirty: {$set: true}});
                default:
                    return {...state};
            }

        case 'AI_SETTINGS_SAVE':
            return {...state, saved: false, saving: true};

        case 'AI_SETTINGS_SAVED':
            return {...state, saved: false, saving: false, dirty: false};

        case 'AI_SETTINGS_REQUEST_FAILED':
            return {...state, saving: false};

        default:
            return {...state};
    }
};

export default AiSettings;
